<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="Client replica"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreReplica/ClientReplica/ClientReplicaDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
                color="primary"
                size="20"
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
      </template>
      <template v-slot:item.is_provider="{ item }">
        <v-checkbox v-model="item.is_provider" dense></v-checkbox>
      </template>
      <template v-slot:item.is_customer="{ item }">
        <v-checkbox v-model="item.is_customer" dense></v-checkbox>
      </template>
      <template v-slot:item.is_material_owner="{ item }">
        <v-checkbox v-model="item.is_material_owner" dense></v-checkbox>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import ClientReplicaDetail from "@/components/CoreReplica/ClientReplica/ClientReplicaDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "ClientReplicaTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'ClientReplicaTable'},
    dtoDetailQuery: {default: 'ClientReplicaDetailQueryDTO'},
    detailStoreName: {default: 'ClientReplicaDetail'},
    dtoValidateCommand: {type: [String], default: 'ClientReplicaValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'ClientReplicaListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ClientReplicaActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    ClientReplicaDetail,
    BaseFieldCheck,
  },

  methods: {
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'N', value: 'notion_id', sortable: true, filterable: true, divider: true, width: 30},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true},
      {text: 'Client ID', value: 'alias', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>